module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='There are no players to fit your search criteria, please update filters.';
}
return __p;
};
